import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Axxess Training and "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, " Certification ")
], -1 /* HOISTED */)
const _hoisted_3 = {
  class: "far fa-bell",
  style: {"color":"#337ab7 !important","font-size":"20px"}
}
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Axxess Training and ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, " Certification ", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  id: "App__Agencies_Vue"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Axxess Training and Certification ", -1 /* HOISTED */)
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Training Hub", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Training Reports", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "SimiTree", -1 /* HOISTED */)
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "SimiTree MAP Home Health", -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "SimiTree MAP Hospice", -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayRoutes, (route) => {
      return (_openBlock(), _createElementBlock("span", {
        key: route,
        onClick: ($event: any) => (_ctx.goToRoute(route.path)),
        class: _normalizeClass(`btn btn-vue btn-block-vue ${_ctx.isActivePath(route.path) ? 'active' : ''}`)
      }, [
        _createElementVNode("b", null, _toDisplayString(route.meta.menuName), 1 /* TEXT */)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    }), 128 /* KEYED_FRAGMENT */)),
    (_ctx.hasCertificationAccess && _ctx.showBellIcon && !_ctx.canViewReports)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:void(0)",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToCertification && _ctx.redirectToCertification(...args))),
          class: "btn btn-vue btn-block-vue d-flex align-items-center justify-content-between"
        }, [
          _hoisted_2,
          _withDirectives(_createElementVNode("i", _hoisted_3, null, 512 /* NEED_PATCH */), [
            [_directive_tooltip, {
                title: `New Courses Now Live`,
                placement: 'top',
                className: 'lock-premium'
            }]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.hasCertificationAccess && !_ctx.showBellIcon && !_ctx.canViewReports)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          target: "_blank",
          href: _ctx.certificationUrl,
          class: "btn btn-vue btn-block-vue"
        }, _hoisted_8, 8 /* PROPS */, _hoisted_4))
      : _createCommentVNode("v-if", true),
    (_ctx.getCertificationAccess && _ctx.canViewReports)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("header", {
            class: "group-title-vue",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTrainingListShow()))
          }, [
            _hoisted_10,
            _createElementVNode("i", {
              class: _normalizeClass(`me-1 ms-auto arrow-color fas fa-caret-${_ctx.listShow ? 'down' : 'up'}`)
            }, null, 2 /* CLASS */)
          ]),
          _withDirectives(_createElementVNode("a", {
            target: "_blank",
            href: _ctx.certificationUrl,
            class: "btn btn-vue btn-block-vue"
          }, _hoisted_13, 8 /* PROPS */, _hoisted_11), [
            [_vShow, _ctx.trainingListShow]
          ]),
          _withDirectives(_createElementVNode("a", {
            target: "_blank",
            href: _ctx.certificationReportsUrl,
            class: "btn btn-vue btn-block-vue"
          }, _hoisted_16, 8 /* PROPS */, _hoisted_14), [
            [_vShow, _ctx.trainingListShow]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Hiding premium feature until asked to unhide "),
    _createCommentVNode(" <div id=\"App__Agencies_Vue\" v-if=\"simitreeHHPermission || simitreeHOSPermission\"\r\n        :class=\"`${!canShowPremium ? 'ai-disabled' : ''}`\">\r\n        <header class=\"group-title-vue\" @click=\"toggleListShow()\">\r\n            <span>SimiTree</span>\r\n            <div class=\"d-flex\" v-if=\"canShowPremium\">\r\n                <button class=\"ai-premium-btn ms-2\">Premium</button>\r\n            </div>\r\n            <div class=\"d-flex\" v-else>\r\n                <button\r\n                    class=\"ai-premium-btn ms-2\"\r\n                    v-tooltip=\"{\r\n                        title: `Contact Axxess to unlock this <br /> premium Axxess intelligence feature.`,\r\n                        placement: 'top',\r\n                        className: 'lock-premium'\r\n                    }\"\r\n                >\r\n                    Premium\r\n                    <img src=\"../../../../assets/images/lock-planner.svg\" />\r\n                </button>\r\n            </div>\r\n            <i :class=\"`me-1 ms-auto arrow-color fas fa-caret-${listShow ? 'down' : 'up'}`\"></i>\r\n        </header> "),
    (_ctx.simitreeHHPermission || _ctx.simitreeHOSPermission)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          id: "App__Agencies_Vue",
          class: _normalizeClass(`${!_ctx.canShowPremium ? 'ai-disabled' : ''}`)
        }, [
          _createElementVNode("header", {
            class: "group-title-vue",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleListShow()))
          }, [
            _hoisted_17,
            _createElementVNode("i", {
              class: _normalizeClass(`me-1 ms-auto arrow-color fas fa-caret-${_ctx.listShow ? 'down' : 'up'}`)
            }, null, 2 /* CLASS */)
          ]),
          (_ctx.simitreeHHPermission)
            ? _withDirectives((_openBlock(), _createElementBlock("a", {
                key: 0,
                target: "_blank",
                href: _ctx.simiTreeHHUrl,
                class: "btn btn-vue btn-block-vue"
              }, _hoisted_20, 8 /* PROPS */, _hoisted_18)), [
                [_vShow, _ctx.listShow]
              ])
            : _createCommentVNode("v-if", true),
          (_ctx.simitreeHOSPermission)
            ? _withDirectives((_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                href: _ctx.simiTreeHOSUrl,
                class: "btn btn-vue btn-block-vue"
              }, _hoisted_23, 8 /* PROPS */, _hoisted_21)), [
                [_vShow, _ctx.listShow]
              ])
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}